import { render } from "./Step_3.vue?vue&type=template&id=1c5029f0"
import script from "./Step_3.vue?vue&type=script&lang=js"
export * from "./Step_3.vue?vue&type=script&lang=js"

import "./Step_3.vue?vue&type=style&index=0&id=1c5029f0&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__